import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { Container, Row } from 'reactstrap';
import BreadcrumbWithFilter from 'src/components/Common/BreadcrumbWithFilter/BreadCrumbWithFilter'
import { ROUTER } from 'src/constants/routes'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducerState } from 'src/store/reducers'
import { CurrencyFormatter, formatDateMEL } from 'src/helpers/common_helpers';
import StatusHghlighter from 'src/components/Common/StatusHighlighter/StatusHighlighter'
import {
  clearDeclarationMessage,
  getDeclarationFormByIdLoading,
  mailDeclarationFormLoading,
  printDeclarationFormLoading,
  resetDeclarationMessage,
} from 'src/store/actions';
import { useToast } from "src/components/Common/ReactToaster";
import ValidationPopup from 'src/components/Common/ValidationMessage/ValidationPopup';
import DataTableWrapper from 'src/components/Grid/DataTableWrapper'
import { Columns } from 'src/models/components/dataTableWrapperModel'
import { Link } from 'react-router-dom'


const DeclarationView = () => {
  const navigate = useNavigate()
  const { id } = useParams()

  const { error, message, loading, declarationFormDetails } = useSelector(
    (state: RootReducerState) => state.DeclarationReducer
  );
  const dispatch = useDispatch();

  useEffect(() => {
    const preloader: any = document.getElementById("preloader");
    if (loading) {
      preloader.style.display = "block";
    } else {
      preloader.style.display = "none";
    }
  }, [loading]);

  const statusBodyTemplate = (value: boolean) => {
    let status = value;
    return (
      <StatusHghlighter status={status} />
    )
  }


  const [visible, setVisible] = useState(false);
  const { showToast } = useToast();
  const [deleteModal, setDeleteModal] = useState(false);

  useEffect(() => {
    if (error) {
      setVisible(true);
    }
    if (message) {
      showToast(message, { type: "success" });
      dispatch(clearDeclarationMessage());
    }
  }, [error, message]);

  const hidePopup = () => {
    setVisible(false);
    dispatch(clearDeclarationMessage())
  };

  const dialogContainer = (error: any) => {
    return (
      <>
        <ValidationPopup error={error} visible={visible} onHide={hidePopup} />
      </>
    );
  };

  useEffect(() => {
    if (id) {
      dispatch(getDeclarationFormByIdLoading(id));
    }
    return () => {
      dispatch(resetDeclarationMessage());
    };
  }, []);


  const userView = {
    generalDetails: [
      {
        name: "DC Number",
        value: declarationFormDetails?.dcNumber
      },
      {
        name: "Type",
        value: declarationFormDetails?.type == "R" ? "Returnable" : declarationFormDetails?.type == "NR" ? "Non Returnable" : <div className='view-none-text'>-</div>
      },
      {
        name: "Supplier Name",
        value: declarationFormDetails?.supplierName
      },
      {
        name: "Supplier Address",
        value: declarationFormDetails?.supplierAddress
      },
      {
        name: "Supplier Mobile",
        value: declarationFormDetails?.supplierMobile
      },
      {
        name: "Supplier Email",
        value: declarationFormDetails?.supplierEmail
      },
      {
        name: "Supplier GST Number",
        value: declarationFormDetails?.supplierGSTNumber
      },
      {
        name: "Notes",
        value: declarationFormDetails?.notes
      }
    ]
  }

 

  const editDeclarationForm = () => {
    navigate(`${ROUTER.DECLARATION_EDIT}/${id}`)
  }

  const createDeclarationForm = () => {
    navigate(`${ROUTER.DECLARATION_CREATE}`)
  }

  const printDeclarationForm = () => {
    dispatch(printDeclarationFormLoading(id));
  }

  const headerTemplate =(val:any)=>{
    return(
      <div className="d-flex justify-content-start">
        <div className="d-flex justify-content-end"style={{width:"100px"}}  >
        <div className="align-right">
          {val}
        </div>
        </div>
      </div>
    )
    }
  const partDetailsColumn: Columns[] = [
    {
      field: "defectSkus",
      sortable: false,
      header: "SKU Number",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap", width: "250px" },
      className:"partSku",
      isDefault: true,
      isStatic: true,

    },
    {
      field: "jobNumber",
      sortable: false,
      header: "Job Number",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap", width: "250px" },
      isDefault: true,
      isStatic: true,

    },
    {
      field: "vinNumber",
      sortable: false,
      header: "VIN Number",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap", width: "250px" },
      isDefault: true,
      isStatic: true,

    },
    {
      field: "totalPrice",
      sortable: false,
      header: "Total",
      filter: false,
      showFilterMenu: false,
      body:(rowData:any)=>headerTemplate(rowData.totalPrice),
      headerStyle: { whiteSpace: "nowrap", width: "250px" },
      isDefault: true,
      isStatic: true,
    },
    {
      field: "remarks",
      sortable: false,
      header: "Remarks",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap", width: "250px" },
      isDefault: true,
      isStatic: true,
    }
  ];

  const mailDeclarationForm =() => {
    dispatch(mailDeclarationFormLoading(id))
  }

  return (
    <React.Fragment>
      <div className='userpage'>
        {visible && dialogContainer(error)}
       
        <Container fluid>
          <BreadcrumbWithFilter
            title="Delivery Challan" titlePath={ROUTER.DECLARATION_GRID} breadcrumbItem='Delivery Challan Details'
            isShowCreate={false}
            isShowFilter={false}
            filter={false}

            isShowFirstButton={ true}
            firstButtonLabel='Edit Delivery Challan'
            onFirstButtonClick={editDeclarationForm}

            isShowThirdButton={true}
            thirdButtonLabel='Mail Delivery Challan'
            onThirdButtonClick={mailDeclarationForm}

            isShowForthButton={true}
            forthButtonLabel='Print Delivery Challan'
            forthButtonDisabled={false}
            onForthButtonClick={printDeclarationForm}

            isShowFifthButton={true}
            fifthButtonLabel='New Delivery Challan'
            onFifthButtonClick={createDeclarationForm}



          />
          <Row>
            <div className="view">
              <div className="general-details">
                <b>General Details</b>
              </div>
              <div className="subview">
              <div className="parentCls">
                  {
                    userView.generalDetails.map((data, index) => {
                      return (
                        <div key={index} className={` pt-1 childCls`}>
                          <div>{data.name}</div>
                          <div>{data.value ? data.value : <div className='view-none-text'>-</div>}</div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </div>           
          </Row>

          <Row>
            {declarationFormDetails?.dcFormDetails?.length > 0 &&
              <Row>
                <div className="view">
                  <div className="general-details">
                    <b>Sku Details</b>
                  </div>
                  <div className="subview">
                    <Row>
                      <div className="card ps-0 pe-0">
                        <DataTableWrapper
                          columnDetails={partDetailsColumn}
                          value={declarationFormDetails?.dcFormDetails}
                        >
                        </DataTableWrapper>
                      </div>
                    </Row>
                  </div>
                </div>
              </Row>
            }
          </Row>

        </Container>
      </div >
    </React.Fragment >
  )
}

export default DeclarationView